import { gql, useMutation } from '@apollo/client';
import { USER_FIELDS, User } from './useUserQuery';

const ASSIGN_EXISTING_USER = gql`
  ${USER_FIELDS}
  mutation AssignExistingUser($email: String!, $enabledCompanies: [String!]!) {
    assignExistingUser(email: $email, enabledCompanies: $enabledCompanies) {
      ...UserFields
    }
  }
`;

export interface UserAssignExistingInput {
  email: string;
  enabledCompanies: string[];
}

export interface UserAssignExistingResult {
  assignExistingUser: User;
}

/**
 * Assign the selected companies (Mandanten) to an already-existing user instead
 * of inviting them again. Offered when inviteUser fails with USER_ALREADY_EXISTS.
 */
export function useAssignExistingUserMutation() {
  return useMutation<UserAssignExistingResult, UserAssignExistingInput>(ASSIGN_EXISTING_USER, {
    refetchQueries: ['GetUser'],
  });
}
